import React from "react";
import { Tabs } from "antd";  // Correct way to import Tabs from Ant Design
import { PatternBackground } from "../../components/PatternBackground";  // Assuming PatternBackground is correct
import MemberStatementTable from "./MemberStatementTable";  // Assuming it's correctly exported
import CompanyStatementTable from "./CompanyStatementTable";  // Assuming it's correctly exported
import MemberOfCertificateTable from "./MemberOfCertificateTable";  // Assuming it's correctly exported

const { TabPane } = Tabs;

export const StatementPage = () => {
  return (
    <div>
      <PatternBackground>
        <p className="lead fw-bold">Statements</p>
        <small>View all statements</small>  {/* Fixed minor typo */}
      </PatternBackground>

      <div className="om-container">
        <div className="p-4 shadow-sm bg-white rounded">
          <div className="mt-5">
            <Tabs defaultActiveKey="1">
              <TabPane tab="Member Statement" key="1">
                <MemberStatementTable />
              </TabPane>
              <TabPane tab="Company Statement" key="2">
                <CompanyStatementTable />
              </TabPane>
              <TabPane tab="Member Certificates" key="3">
                <MemberOfCertificateTable />
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};
